import React from 'react';
import classnames from 'classnames';
import Link from '../../../components/link';
import './index.css';
import {HashLink} from 'react-router-hash-link';

export default function PinkButton({link, hash, text, gtm = '', style, bgColor = 'pink', func, square = false, href, className = '', id = '', isNewTab}) {
  const btnClassNames = classnames(
    {
      'pf-btn': true,
      'pf-pink-btn': bgColor === 'pink',
      'pf-grey-btn': bgColor === 'grey',
      'pf-black-btn': bgColor === 'black',
      'pf-white-btn': bgColor === 'white',
      'pf-linear-btn': bgColor === 'linear',
      'pf-square-btn': square,
      [gtm]: !!gtm,
    },
    className
  );
  if (hash) {
    return (
      <HashLink className={btnClassNames} style={style} to={hash} onClick={func} id={id}>
        {text}
      </HashLink>
    );
  }

  return link ? (
    <Link className={btnClassNames} to={link} style={style} onClick={func} id={id} isNewTab={isNewTab}>
      {text}
    </Link>
  ) : (
    <a className={btnClassNames} href={href} style={style} target={isNewTab ? '_blank' : '_self'} onClick={func} id={id}>
      {text}
    </a>
  );
}
